import {useCallback} from "react";
import {useAppSelector} from "../../../redux/hooks";
import {
  getIsMySongsPageFilterArrangementTypeIdSelected
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterFeatureArrangementTypeLogic {
  title?: string;
  isSelected: boolean;
  handleToggleOnClick: () => void;
}

export const useFilterFeatureArrangementTypeLogic = (arrangementTypeId: number): IFilterFeatureArrangementTypeLogic => {
  const title = useAppSelector(() => mySongsFiltersStore.getArrangementTypeTitleFromId(arrangementTypeId))
  const isSelected = useAppSelector((store) => getIsMySongsPageFilterArrangementTypeIdSelected(store, arrangementTypeId));
  const handleToggleOnClick = useCallback(() => {
    mySongsPageStore.toggleFilterArrangementTypeId(arrangementTypeId);
  }, [arrangementTypeId]);
  return {
    title,
    isSelected,
    handleToggleOnClick,
  };
}
